import { render, staticRenderFns } from "./XssMatch.vue?vue&type=template&id=6f22920a&"
import script from "./XssMatch.vue?vue&type=script&lang=js&"
export * from "./XssMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports